import React from "react";
import { svgs } from "../assats";
import LeftRightEar from "../../components/LeftRightEar";
import { Patient } from "../types/patientType";
export function organizePatientData(data: Patient[]) {
  if (!data || data.length === 0) {
    return [];
  }
  // Check if data is an array and has elements
  if (!Array.isArray(data) || data.length === 0) {
    return [];
  }
  let res = data.map((val) => {
    return {
      firstName: val.firstName,
      lastName: val.lastName,
      gender:
        val.gender === "Male" ? <svgs.icons.Male /> : <svgs.icons.Female />,
      ear:
        val.ear === "left" ? (
          <LeftRightEar ear="l" />
        ) : (
          <LeftRightEar ear="r" />
        ),
      identityNumber: val.identityNumber,
      email: val.email,
      phoneNumber: val.phoneNumber,
      status: val.status,
      center: val.center,
      relatedHCP: val.relatedHCP || "",
      created: val.created,
    };
  });

  return res;
}
